<template>
  <div clipboard >
    <button type="button" class="btn-share" @click="copyUrl()">
      <span>공유하기</span>
    </button>    
    <div id="clipboard-box" >
      <p>링크 복사 완료</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'clipboard',
  data() {
    return {}
  },
  methods: {
    showClipBoard() {
      const copyBox = document.getElementById('clipboard-box');
      copyBox.classList.add('show');
      setTimeout(() => {
        copyBox.classList.remove('show');
      }, 3000); 
    },
    copyUrl() {
      this.nowUrl = window.location.href;

      if (navigator.clipboard !== undefined) {
        window.navigator.clipboard.writeText(this.nowUrl)
        .then(() => { 
          this.showClipBoard();
        });
      } else {
        const textarea = document.createElement("textarea");
        document.body.appendChild(textarea);
        textarea.value = this.nowUrl;
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
    }
  }
};
</script>

<style lang="less">
@import "~@/less/proj";
[clipboard] {
  .btn-share {
    .mt(32);
    span {
      .ib;
      .fs(14, 26, -0.5);
      .medium;
      color: #616161;
      &:before {
        .ib;
        .wh(20);
        .mr(8);
        .cover("/img/tech/people/ico-share-default.svg");
        .vam;
        content: '';
      }
    }
    &:hover {
      span {
        .ib;
        color: #0777ff;
        &:before {
          .cover("/img/tech/people/ico-share-hover.svg");
        }
      }
    }
  }
  #clipboard-box {
    .hide;
    .abs;
    .l(50%);
    .b(35);
    .xc;
    .wh(80, 26);
    .p(4, 20, 6);
    .-a(#4e4e4e);
    .br(4);
    background-color: #222;
    p {
      .fs(14, 26, -0.5);
      color: #fff;
    }
    &.show {
      .block;
      animation: fadeInOut 1.5s .5s ease-in-out both;
    }
  }
  @keyframes fadeInOut {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
}
}
</style>